'use client';

import React, { useEffect } from 'react';
import { Chips } from 'organisms/Filters/Chips';
import { useFilters } from 'organisms/Filters/hooks';
import { IFilter } from 'commerce/factFinder/types';
import styles from './styles.module.css';

export const BrandsFilter = ({ brands }: { brands: IFilter[] }) => {
  const { filters, handleSearch } = useFilters();

  useEffect(() => {
    handleSearch();
  }, [filters]);

  return (
    <div>
      <Chips list={brands} isVisible={true} styles={styles} />
    </div>
  );
};
